module.exports = require("composer");